import { gql } from 'apollo-boost';

export const businessTypesQuery = gql`
  {
    referenceData {
      businessTypes {
        enumValue
        name
      }
    }
  }
`;

export const timeZonesQuery = gql`
  {
    referenceData {
      timeZones {
        enumValue
        name
      }
    }
  }
`;

export const culturesQuery = gql`
  {
    referenceData {
      cultures {
        enumValue
        name
      }
    }
  }
`;

export const stateCodesQuery = gql`
  {
    referenceData {
      stateCodes {
        enumValue
        name
      }
    }
  }
`;

export const countryCodesQuery = gql`
  {
    referenceData {
      countryCodes {
        enumValue
        name
      }
    }
  }
`;

export const shipmentStatusesQuery = gql`
  {
    referenceData {
      shipmentStatuses {
        enumValue
        name
      }
    }
  }
`;

export const shipmentModesQuery = gql`
  {
    referenceData {
      shipmentModes {
        enumValue
        name
      }
    }
  }
`;

export const freightClassesQuery = gql`
  {
    referenceData {
      freightClasses {
        enumValue
        name
      }
    }
  }
`;

export const packageTypesQuery = gql`
  {
    referenceData {
      packageTypes {
        enumValue
        name
      }
    }
  }
`;

export const currenciesQuery = gql`
  {
    referenceData {
      currencies {
        enumValue
        name
      }
    }
  }
`;

export const dimensionUnitsQuery = gql`
  {
    referenceData {
      dimensionUnits {
        enumValue
        name
      }
    }
  }
`;

export const weightUnitsQuery = gql`
  {
    referenceData {
      weightUnits {
        enumValue
        name
      }
    }
  }
`;

export const volumeUnitsQuery = gql`
  {
    referenceData {
      volumeUnits {
        enumValue
        name
      }
    }
  }
`;

export const densityUnitsQuery = gql`
  {
    referenceData {
      densityUnits {
        enumValue
        name
      }
    }
  }
`;

export const hazMatClassesQuery = gql`
  {
    referenceData {
      hazMatClasses {
        enumValue
        name
      }
    }
  }
`;

export const hazMatPackingGroupsQuery = gql`
  {
    referenceData {
      hazMatPackingGroups {
        enumValue
        name
      }
    }
  }
`;

export const shipmentNoteTypesQuery = gql`
  {
    referenceData {
      shipmentNoteTypes {
        enumValue
        name
      }
    }
  }
`;

export const shipmentStopStatuses = gql`
  {
    referenceData {
      shipmentStopStatuses {
        enumValue
        name
      }
    }
  }
`;

export const shipmentDirections = gql`
  {
    referenceData {
      shipmentDirections {
        enumValue
        name
      }
    }
  }
`;

export const packageTypes = gql`
  {
    referenceData {
      packageTypes {
        enumValue
        name
      }
    }
  }
`;

export const accessorialServices = gql`
  {
    referenceData {
      accessorialServices {
        enumValue
        name
        description
      }
    }
  }
`;

export const equipmentTypes = gql`
  {
    referenceData {
      equipmentTypes {
        enumValue
        name
        description
      }
    }
  }
`;

export const shipmentStatuses = gql`
  {
    referenceData {
      shipmentStatuses {
        enumValue
        name
      }
    }
  }
`;

export const hazMatClasses = gql`
  {
    referenceData {
      hazMatClasses {
        enumValue
        name
      }
    }
  }
`;

export const hazMatPackingGroups = gql`
  {
    referenceData {
      hazMatPackingGroups {
        enumValue
        name
      }
    }
  }
`;

export const chargeCategories = gql`
  {
    referenceData {
      chargeCategories {
        enumValue
        name
      }
    }
  }
`;

export const contractClassifications = gql`
  {
    referenceData {
      contractClassifications {
        enumValue
        name
      }
    }
  }
`;

export const laneTypes = gql`
  {
    referenceData {
      laneTypes {
        enumValue
        name
      }
    }
  }
`;

export const paymentTerms = gql`
  {
    referenceData {
      paymentTerms {
        enumValue
        name
      }
    }
  }
`;

export const rateQualifiers = gql`
  {
    referenceData {
      rateQualifiers {
        enumValue
        name
      }
    }
  }
`;

export const serviceLevels = gql`
  {
    referenceData {
      serviceLevels {
        value
        name
        description
      }
    }
  }
`;

export const shipmentStopArrivals = gql`
  {
    referenceData {
      shipmentStopArrivals {
        enumValue
        name
      }
    }
  }
`;

export const orgUserRoles = gql`
  {
    referenceData {
      orgUserRoles {
        enumValue
        name
        description
      }
    }
  }
`;

export const chargeCodes = gql`
  {
    referenceData {
      chargeCodes {
        enumValue
        name
      }
    }
  }
`;

export const accessorialServiceTypes = gql`
  {
    referenceData {
      accessorialServiceTypes {
        enumValue
        name
      }
    }
  }
`;

export const rateProviders = gql`
  {
    referenceData {
      rateProviders {
        enumValue
        name
      }
    }
  }
`;

export const lcpExceptionReasons = gql`
  query orgRef_LcpExceptionReason($orgId: ID!) {
    orgRef_LcpExceptionReason {
      all(orgId: $orgId) {
        name
        description
        id
      }
    }
  }
`;

export const glCodes = gql`
  query orgRef_GlCode($orgId: ID!) {
    orgRef_GlCode {
      all(orgId: $orgId) {
        name
        description
        id
      }
    }
  }
`;

export const productCategories = gql`
  query productCategories($orgId: ID!) {
    orgRef_ProductCategory {
      all(orgId: $orgId) {
        name
        description
        id
      }
    }
  }
`;

export const fileTypes = gql`
  {
    referenceData {
      fileTypes {
        name
        enumValue
      }
    }
  }
`;

export const filePurposes = gql`
  {
    referenceData {
      filePurposes {
        name
        enumValue
      }
    }
  }
`;

export const checkDigitTypes = gql`
  {
    referenceData {
      checkDigitTypes {
        name
        enumValue
      }
    }
  }
`;

export const shipmentDocumentTypes = gql`
  {
    referenceData {
      shipmentDocumentTypes {
        name
        enumValue
      }
    }
  }
`;

export const notificationReasons = gql`
  {
    referenceData {
      notificationReasons {
        name
        enumValue
      }
    }
  }
`;

export const netTerms = gql`
  {
    referenceData {
      netTermses {
        name
        enumValue
      }
    }
  }
`;

// This query combines the org level reference queries.  May be more added here.
export const initialOrgRefs = gql`
  query orgRefs($orgId: ID!) {
    orgRef_LcpExceptionReason {
      all(orgId: $orgId) {
        name
        description
        id
      }
    }
    orgRef_GlCode {
      all(orgId: $orgId) {
        name
        description
        id
        externalId
      }
    }
  }
`;

// this query combines queries for all the references we should need with every shipment so they can be loaded together
// when first entering the screen instead of individual hits for each one
export const initialRefs = gql`
  {
    referenceData {
      shipmentModes {
        enumValue
        name
      }
    }
    referenceData {
      shipmentDirections {
        enumValue
        name
      }
    }
    referenceData {
      packageTypes {
        enumValue
        name
      }
    }
    referenceData {
      freightClasses {
        enumValue
        name
      }
    }
    referenceData {
      accessorialServices {
        enumValue
        name
        description
      }
    }
    referenceData {
      equipmentTypes {
        enumValue
        name
        description
      }
    }
    referenceData {
      serviceLevels {
        enumValue
        name
        description
      }
    }
    referenceData {
      hazMatClasses {
        enumValue
        name
      }
    }
    referenceData {
      hazMatPackingGroups {
        enumValue
        name
      }
    }
    referenceData {
      shipmentStatuses {
        enumValue
        name
      }
    }
    referenceData {
      fileTypes {
        name
        enumValue
      }
    }
    referenceData {
      filePurposes {
        name
        enumValue
      }
    }
    referenceData {
      shipmentDocumentTypes {
        name
        enumValue
      }
    }
    referenceData {
      customFieldTypes {
        enumValue
        name
      }
    }
    referenceData {
      timeZones {
        enumValue
        name
      }
    }
    referenceData {
      unitTypes {
        enumValue
        name
      }
    }
    referenceData {
      cultures {
        enumValue
        name
      }
    }
    referenceData {
      country {
        enumValue
        name
      }
    }
    referenceData {
      currencies {
        enumValue
        name
      }
    }
    referenceData {
      rateProviders {
        enumValue
        name
      }
    }
    referenceData {
      netTermses {
        enumValue
        name
      }
    }
    referenceData {
      notificationReasons {
        enumValue
        name
      }
    }
    referenceData {
      laneTypes {
        enumValue
        name
      }
    }
  }
`;
